module.exports = __webpack_public_path__ + "img/1-6.99ad09b1.png";